import { Component } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-approve-document-reason',
  templateUrl: './approve-document-reason.component.html',
  styleUrls: ['./approve-document-reason.component.sass'],
  imports: [FormsModule, ReactiveFormsModule],
})
export class ApproveDocumentReasonComponent {
  constructor(
    private fb: FormBuilder,
    public dialogRef: DynamicDialogRef<ApproveDocumentReasonComponent>
  ) {}
  isSaveButtonEnabled: boolean = false;
  maxCharacteresAllowed = 1000;
  typedCharacteres = 0;

  approveDocumentForm = this.fb.group({
    notes: ['', Validators.required],
  });

  submit() {}

  notesTyped(event: any) {
    let value =
      this.approveDocumentForm.controls?.notes.value?.trimStart().length ===
      undefined
        ? 0
        : this.approveDocumentForm.controls?.notes.value?.trimStart().length;

    this.typedCharacteres = value;

    this.isSaveButtonEnabled = value > 0;
  }

  cancel() {
    this.dialogRef.close();
  }

  saveReason() {
    this.dialogRef.close({
      approveReason: this.approveDocumentForm.controls.notes.value,
    });
  }
}
